import styled from 'styled-components';

export const ForceGreenMsg = styled.span`
  font-size: 12px;
  margin-left: 5px;
  color: #888;
`;
